export default function SendIcon() {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.55691 5.28372C9.61364 5.23247 9.65422 5.15988 9.67078 5.08002C9.68734 5.00016 9.6787 4.91874 9.64654 4.85156C9.61437 4.78437 9.56098 4.73622 9.49672 4.71643C9.43245 4.69665 9.36191 4.70666 9.29877 4.74451L3.30343 8.33675L1.13575 6.50795C1.04131 6.42893 0.970779 6.31714 0.932544 6.18587C0.894309 6.0546 0.889974 5.90938 0.920053 5.76745C0.950133 5.62552 1.01336 5.49285 1.10223 5.38522C1.1911 5.27758 1.30186 5.1995 1.42137 5.16025L13.5918 0.917049C13.6869 0.885813 13.7849 0.885007 13.8753 0.914717C13.9657 0.944426 14.0452 1.00354 14.1052 1.08574C14.1653 1.16794 14.2037 1.27015 14.2162 1.38146C14.2288 1.49276 14.2151 1.60899 14.1767 1.71773L10.2113 12.9046C10.1709 13.0194 10.1091 13.124 10.031 13.2101C9.95291 13.2962 9.86058 13.3614 9.76137 13.4005C9.66217 13.4397 9.55883 13.4517 9.45958 13.4355C9.36033 13.4194 9.26791 13.3756 9.18967 13.3077L6.55195 11.0803L4.07986 12.7282C3.98869 12.7888 3.88703 12.818 3.78747 12.8123C3.68791 12.8065 3.5948 12.7661 3.51968 12.696C3.44455 12.6258 3.39069 12.529 3.36477 12.4176C3.33885 12.3062 3.342 12.1849 3.37382 12.069L3.82742 10.3761L9.55691 5.28372Z"
        fill="#131313"
      />
    </svg>
  );
}
